import DashboardModuleLayout from "@/views/Pages/DashboardModule/DashboardModuleLayout.vue";

// import middleware
import authenticated from "@/middleware/authenticated";
import authorized from "@/middleware/authorized";
import permissions from "@/constants/permissions";

// const Dashboard = () =>
//   import("@/views/Pages/DashboardModule/Dashboard/Dashboard.vue");
const WidgetsDashboard = () =>
  import("@/views/Pages/DashboardModule/Dashboard/WidgetsDashboard.vue");

const InternalPreparationsPage = () =>
  import(
    "@/views/Pages/DashboardModule/InternalPreparations/InternalPreparationsPage.vue"
  );

const SupplyRuleView = () =>
  import(
    "@/views/Pages/DashboardModule/Dashboard/SupplyRule/SupplyRuleView.vue"
  );

const EstablishmentDirectoryPage = () =>
  import(
    "@/views/Pages/DashboardModule/EstablishmentsDirectory/EstablishmentDirectoryPage.vue"
  );

const EventsPage = () =>
  import(
    "@/views/Pages/DashboardModule/Events/EventsPage.vue"
  );

const CashRegisterReadingsReportsPage = () =>
  import(
    "@/views/Pages/DashboardModule/Reports/CashRegisterReadingsReportsPage.vue"
  );

const CashRegistersReportsPage = () =>
  import(
    "@/views/Pages/DashboardModule/Reports/CashRegistersReportsPage.vue"
  );

const ProductsReportPage = () =>
  import(
    "@/views/Pages/DashboardModule/Reports/ProductsReportPage.vue"
  );

const PosProductsReportPage = () =>
  import(
    "@/views/Pages/DashboardModule/Reports/PosProductsReportPage.vue"
  );

const WeeklyReportsReportsPage = () =>
  import(
    "@/views/Pages/DashboardModule/Reports/WeeklyReportsReportsPage.vue"
  );

let dashBoardsPages = {
  path: "",
  component: DashboardModuleLayout,
  children: [
    {
      path: "dashboard",
      name: "Dashboard",
      component: WidgetsDashboard,
      meta: { middleware: authenticated },
    },
    {
      // Productions à faire: the kitchen list, next to the dashboard.
      path: "productions",
      name: "Internal Preparations",
      component: InternalPreparationsPage,
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_ORDERS,
      },
    },
    {
      path: "establishments-directory",
      name: "EstablishmentDirectory",
      component: EstablishmentDirectoryPage,
      meta: { middleware: authenticated },
    },
    {
      path: "supply-rule",
      name: "Supply-Rule",
      component: SupplyRuleView,
      meta: { middleware: authenticated },
    },
    {
      path: "events",
      name: "events",
      component: EventsPage,
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_EVENTS,
      },
    },
  ],
};

let reportsPages = {
  path: "reports",
  component: DashboardModuleLayout,
  children: [
    {
      path: "cashregister-readings",
      name: "CashRegisterReadingsReportsPage",
      component: CashRegisterReadingsReportsPage,
      meta: { middleware: authenticated },
    },
    {
      path: "cashregisters",
      name: "CashRegistersReportsPage",
      component: CashRegistersReportsPage,
      meta: { middleware: authenticated },
    },
    {
      path: "products",
      name: "ProductsReportPage",
      component: ProductsReportPage,
      meta: { middleware: authenticated },
    },
    {
      path: "pos-products",
      name: "PosProductsReportPage",
      component: PosProductsReportPage,
      meta: { middleware: authenticated },
    },
    {
      path: "weekly-reports",
      name: "WeeklyReportsReportsPage",
      component: WeeklyReportsReportsPage,
      meta: { middleware: authenticated },
    },
  ],
};

const dashboardModuleRoutes = [dashBoardsPages, reportsPages];

export default dashboardModuleRoutes;
